import { tv, type VariantProps } from "tailwind-variants";

export const floatingImagesVariants = tv({
  slots: {
    base: ["relative", "w-full", "h-full"],
    imageWrapper: [
      "absolute",
      "rounded-md md:rounded-lg",
      "overflow-hidden",
      "will-change-transform",
      "pointer-events-none",
    ],
    image: ["w-full h-auto", "select-none", "pointer-events-none object-cover"],
  },
  variants: {
    size: {
      xs: {
        imageWrapper: ["w-16", "desktop:w-26"],
      },
      sm: {
        imageWrapper: ["w-24", "desktop:w-32"],
      },
      md: {
        imageWrapper: ["w-32", "desktop:w-44"],
      },
      lg: {
        imageWrapper: ["w-40", "desktop:w-56"],
      },
      xl: {
        imageWrapper: ["w-48", "desktop:w-64"],
      },
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export type FloatingImagesVariantProps = VariantProps<typeof floatingImagesVariants>;
export type FloatingImagesReturnVariantProps = ReturnType<typeof floatingImagesVariants>;
